const QuickLinks = {};

export default QuickLinks